module.exports = __webpack_public_path__ + "corsica.svg?065b5edec1eaf3dcb0c75410debceab4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/corsica.svg
// module id = 141
// module chunks = 10